import { Component, OnInit, Input } from "@angular/core";
import { BaseComponent } from "../../base.component";
import { DataService } from "../../_services/data.service";
import { AlertService } from "../../_services/alert.service";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { Router } from "@angular/router";
import { GlobalDataService } from "../../_services/global-data.service";
import { ErrorType } from "../../common/error-handler/error-types.enum";
import { TranslationService } from "../../_services/translation.service";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../_models/ITranslations";

@Component({
  moduleId: module.id,
  selector: "admin",
  templateUrl: "admin.component.html",
  styleUrls: ["admin.component.scss"],
})
export class AdminComponent extends BaseComponent implements OnInit {
  public translations$: Observable<ITranslations>;
  constructor(
    public dataService: DataService,
    private globalDataService: GlobalDataService,
    public sessionManager: SessionManagerService,
    private alertService: AlertService,
    private router: Router,
    private translationService: TranslationService
  ) {
    super(dataService, sessionManager);
    this.checkIfAdminIsLoggedIn().then();
    this.translations$ = this.translationService.translations;
  }

  run() {}

  public ngOnInit() {
    super.ngOnInit();
    if (this.sessionManager.isDevModeActive()) {
      if (this.router.url === "/admin") {
        return;
      }
      this.collapseDiv("#menuContent");
    }
  }

  private async checkIfAdminIsLoggedIn() {
    const message = "נותקת מהמערכת עקב חוסר פעילות. התחבר מחדש.";
    const globalData = await this.globalDataService.getGlobalData();

    if (
      globalData.success === false &&
      globalData.error === ErrorType.Status_401_Unauthorized
    ) {
      this.alertService.error(message, true);
      setTimeout(() => this.router.navigate(["/login"]), 1000);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/admin/admin.component.ts